import React, { useEffect, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Modal from "@mui/material/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { MdDownload } from "react-icons/md";
import { RxCross2 } from "react-icons/rx";

import OrderFulfilment from "./OrderView/OrderFulfilment";
import ConformModal from "./conformModal";
import PrintableOrderDetails from "./PrintableOrderDetails";
import OrderView from "./OrderView/OrderView";
import OrderViewSkeleton from "./OrderView/OrderViewSkeleton";
import OrderScans from "./OrderView/OrderScans";
import CarrierInnerTableLoader from "../../../../../Components/CarrierInnerTableLoader/CarrierInnerTableLoader";

// Legacy (pre-redesign) view — kept working behind the "View Order" action
// while the new OrderView (behind "View Order (Beta)") settles in. Both
// paths share every bit of state/data-fetching/PDF logic below; only the
// visible modal body differs. See `useNewDesign`.
import Header from "./Components/header";
import OrderDetails from "./Components/orderdetails";
import ShipmentSummary from "./Components/shipmentSummary";
import Trackingandnotes from "./Components/trackingandnotes";
import Fulfilment from "./Components/fulfilment";

import html2pdf from "html2pdf.js";
import {
  fetchOrdersByIds,
  fetchSingleOrder,
  fetchOrderStatuses,
} from "../../../../../services/orders.services";
import { useTranslation } from "react-i18next";
import i18n from "../../../../../i18n";
import { useOrderVisibility } from "../../../../../helpers/useOrderVisibility";
import { withStatusChoices } from "../../../../../helpers/storeAccess";

// Why an order couldn't be opened, as the pop-up says it.
const openError = (error) =>
  error?.response?.status === 404
    ? i18n.t("warehouse:orderDetails.orderNoLongerExists")
    : error?.response?.status === 403
      ? i18n.t("warehouse:orderDetails.noAccessToOrder")
      : i18n.t("common:messages.somethingWentWrong");

export default function DetailsModal({
  open,
  setOpen,
  setSnack,
  setOrders,
  orderStatus_initial = null,
  editable = false,
}) {
  const { t } = useTranslation(["warehouse", "common"]);
  // A store's users without "View price": no charges in the redesigned
  // view's fulfilment section (only the status, for whoever can change it).
  // Statuses the role can't pick come greyed out in the status selects.
  const { showPrices, user } = useOrderVisibility();
  const [data, setData] = useState({});
  const [batchData, setBatchData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [additionalCosts, setadditionalCosts] = useState([]);
  const [cost, setcost] = React.useState(null);
  const [value, setValue] = React.useState(null);
  const [additonalPrice, setadditonalPrice] = React.useState(0);
  const [AdditionalCostTotal, setAdditionalCostTotal] = useState(0);
  const [deletedids, setdeletedids] = useState([]);
  const [Packinglist, setPackinglist] = useState(false);
  const [orderPdfType, setorderPdfType] = useState(null);
  const [downloadStatus, setDownloadStatus] = useState("DOWNLOAD ALL");
  // The step shown on the button, in the reader's language (the state keeps the
  // English step names it is compared with).
  const downloadStatusLabel = (status) => {
    const step = /^GENERATING (\d+)\/(\d+)\.\.\.$/.exec(status);
    if (step) {
      return t("orderDetails.generatingStep", { current: step[1], total: step[2] });
    }
    const labels = {
      "DOWNLOAD ALL": t("orderDetails.downloadAll"),
      "PREPARING INDIVIDUAL...": t("orderDetails.preparingIndividual"),
      "PREPARING...": t("orderDetails.preparing"),
      "GENERATING PDF...": t("orderDetails.generatingPdf"),
    };
    return labels[status] ?? status;
  };
  const [downloadingBatch, setDownloadingBatch] = useState(false);
  const [orderStatus, setorderStatus] = useState([]);

  const [selectedStatus, setselectedStatus] = useState(false);
  // The redesigned view's status pop-up (one for the header's status and the
  // fulfilment section's).
  const [betaStatusModal, setBetaStatusModal] = useState(false);
  // What the redesigned view's Fulfil bar fills the pop-up in with (by line
  // id), from the products ticked as picked; null for a status picked
  // straight from the select.
  const [prefill, setPrefill] = useState(null);

  // `open` is `[idOrIds, packinglist, initialStatus, beta]` — the 4th slot
  // opts into the redesigned OrderView; every existing caller that doesn't
  // pass it keeps getting the original layout.
  const useNewDesign = Boolean(open?.[3]);
  const isBatch = Array.isArray(open?.[0]);

  // The redesigned view draws batchData: a status change or saved charges
  // update the open order there too, so the view shows them at once.
  const setOpenOrder = (next) => {
    setData(next);
    setBatchData((orders) =>
      orders.map((order) => (order?.id === next?.id ? next : order)),
    );
  };

  // A status picked in the redesigned view: the status pop-up opens with
  // it, as from the order list. Ids are passed on as the list has them.
  const pickStatus = (value) => {
    const picked = orderStatus.find(
      (status) => String(status.id) === String(value),
    );
    if (!picked) return;
    setPrefill(null);
    setselectedStatus(picked.id);
    setBetaStatusModal(true);
  };

  // The redesigned view's Fulfil bar: the status pop-up as Fulfilled, or as
  // Attention / Partially fulfilled (id 5, as the pop-up has it) filled in
  // from the ticks.
  const fulfilWith = ({ partial, prefill: seed }) => {
    const target = orderStatus.find((status) =>
      partial
        ? String(status.id) === "5"
        : String(status.name ?? "")
            .trim()
            .toLowerCase() === "fulfilled",
    );
    if (!target) return;
    setPrefill(partial ? seed : null);
    setselectedStatus(target.id);
    setBetaStatusModal(true);
  };

  const closeBetaStatusModal = (value) => {
    setBetaStatusModal(value);
    if (!value) setPrefill(null);
  };

  // The header's status select, for whoever can fulfil the order (the same
  // rules as the order list's status dropdown and the old view's).
  const statusControl = (order) => {
    if (!editable || isBatch || Packinglist || !orderStatus?.length) {
      return undefined;
    }
    const current =
      orderStatus.find(
        (status) => String(status.id) === String(order?.fullfilment_status?.id),
      )?.id ?? null;
    const hint =
      order?.type === "Return"
        ? t("orderView.orderIsReturn")
        : order?.status !== "Confirmed"
          ? t("orderView.orderNotConfirmed")
          : String(current) === "6"
            ? "This order is cancelled"
            : "";
    return {
      options: orderStatus,
      value: current,
      onChange: pickStatus,
      fulfil: fulfilWith,
      disabled: Boolean(hint),
      hint,
    };
  };

  const handleClose = () => {
    setOpen(false);
    setData({});
    setadditionalCosts([]);
    setcost(null);
    setValue(null);
    setadditonalPrice(0);
    setAdditionalCostTotal(0);
    setdeletedids([]);
    setorderPdfType(false);
    setBetaStatusModal(false);
    setPrefill(null);
    setLoading(true);
  };
  const getOrder = async (idOrIds) => {
    setLoading(true);
    if (Array.isArray(idOrIds)) {
      try {
        // All the ticked orders in one request.
        const {
          data: results,
          missing,
          error,
        } = await fetchOrdersByIds(idOrIds);
        if (missing.length > 0) {
          const names = missing.map((id) => `#${id}`).join(", ");
          setSnack((snack) => ({
            ...snack,
            open: true,
            text: error
              ? t("orderDetails.someOrdersNotLoaded", { count: missing.length })
              : results.length > 0
                ? t("orderDetails.ordersNotLoadedRestHere", { names, count: missing.length })
                : t("orderDetails.ordersNotLoaded", { names, count: missing.length }),
            severity: results.length > 0 ? "warning" : "error",
          }));
        }
        // None to show: the pop-up closes.
        if (results.length === 0) {
          handleClose();
          return;
        }
        setBatchData(results);
        setData(results[0]); // Set first for single-view components if any
      } catch (error) {
        setSnack((snack) => ({
          ...snack,
          open: true,
          text: t("orderDetails.errorFetchingBatchData"),
          severity: "error",
        }));
      }
    } else {
      let response = await fetchSingleOrder(idOrIds);
      if (!response.error) {
        setData(response?.data?.result);
        setBatchData([response?.data?.result]);
      } else {
        setSnack((snack) => ({
          ...snack,
          open: true,
          text: openError(response.error),
          severity: "error",
        }));
        // Nothing to show: the pop-up closes.
        handleClose();
        return;
      }
    }
    setLoading(false);
  };

  const getOrderStatuses = async () => {
    let response;
    response = await fetchOrderStatuses();
    if (!response.error) {
      setorderStatus(withStatusChoices(user, response?.data?.result));
    }
  };

  useEffect(() => {
    if (open) {
      if (open[0]) {
        getOrder(open[0]);
      }
      setPackinglist(open[1]);
      if (open[2]) {
        setselectedStatus(open[2]);
      }
      if (orderStatus_initial) {
        setorderStatus(withStatusChoices(user, orderStatus_initial));
      } else {
        getOrderStatuses();
      }
    }
  }, [open]);

  // The order's (or its packing list's) PDF file name.
  const pdfName = (id, type) => {
    const targetData = batchData.find((o) => o.order_id === id) || data;
    const firstName = (
      targetData?.order_shipping_address_details?.first_name || ""
    ).trim();
    const lastName = (
      targetData?.order_shipping_address_details?.last_name || ""
    ).trim();
    const orderId = (id || "order").trim();

    return `${orderId}${firstName ? `-${firstName}` : ""}${
      lastName ? `-${lastName}` : ""
    }${type ? "-PackingList" : ""}.pdf`;
  };

  const pdfOptions = (name) => ({
    filename: `${name}`,
    format: "A4",
    jsPDF: { unit: "px", format: [835, 1123.2], orientation: "p" },
    image: { type: "jpeg", quality: 1 },
    pagebreak: { mode: ["avoid-all", "css", "legacy"] },
    html2canvas: { scale: 3, useCORS: true, letterRendering: true },
  });

  // The hidden printable copy of the order, drawn as an order or a packing
  // list (null when it isn't there).
  const printableFor = async (id, type) => {
    setorderPdfType(type ? "packing" : "order");

    // Small delay to ensure the hidden component has re-rendered if the type changed
    await new Promise((resolve) => setTimeout(resolve, 500));

    // Always use ID as it's more reliable than refs inside maps
    const input = document.getElementById(`batch-item-${id}`);
    if (!input) console.error(`Target div #batch-item-${id} not found.`);
    return input;
  };

  const downloadPdf = async (id, type) => {
    const input = await printableFor(id, type);
    if (!input) {
      setorderPdfType(null);
      return;
    }
    const name = pdfName(id, type);
    await html2pdf().set(pdfOptions(name)).from(input).save();
    setorderPdfType(null);
  };

  // The same PDF as a file, for the redesigned view to print, open, share
  // or save: { blob, name }.
  const buildPdf = async (id, type) => {
    const input = await printableFor(id, type);
    try {
      if (!input) throw new Error("The order's PDF couldn't be drawn");
      const name = pdfName(id, type);
      const blob = await html2pdf()
        .set(pdfOptions(name))
        .from(input)
        .outputPdf("blob");
      return { blob, name };
    } finally {
      setorderPdfType(null);
    }
  };

  const downloadIndividualPdfs = async () => {
    setDownloadingBatch(true);
    setDownloadStatus("PREPARING INDIVIDUAL...");
    for (let i = 0; i < batchData.length; i++) {
      const order = batchData[i];
      setDownloadStatus(`GENERATING ${i + 1}/${batchData.length}...`);
      await downloadPdf(order.order_id, Packinglist);
      // Small delay to prevent browser overload
      await new Promise((resolve) => setTimeout(resolve, 800));
    }
    setDownloadingBatch(false);
    setDownloadStatus("DOWNLOAD ALL");
  };

  const downloadAllPdfs = async () => {
    setDownloadingBatch(true);
    setDownloadStatus("PREPARING...");

    // Give time for the hidden batch container to update if needed
    await new Promise((resolve) => setTimeout(resolve, 500));

    setDownloadStatus("GENERATING PDF...");
    const element = document.getElementById("batch-printable-container");
    if (!element) {
      setDownloadingBatch(false);
      setDownloadStatus("DOWNLOAD ALL");
      return;
    }

    const filename = `Batch_${Packinglist ? "Packing_Lists" : "Orders"}_${new Date().getTime()}.pdf`;

    const options = {
      filename: filename,
      margin: 0,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true, logging: false },
      jsPDF: { unit: "px", format: [835, 1123.2], orientation: "portrait" },
      pagebreak: { mode: "css" },
    };

    try {
      await html2pdf().set(options).from(element).save();
    } catch (error) {
      console.error("PDF Batch Generation Error:", error);
      setSnack({
        open: true,
        text: t("orderDetails.errorGeneratingMergedPdf"),
        severity: "error",
      });
    }

    setDownloadingBatch(false);
    setDownloadStatus("DOWNLOAD ALL");
  };

  return (
    <>
      <div
        style={{
          zIndex: "-1000",
          position: "absolute",
          visibility: "hidden",
          left: "-1000px",
          top: "-1000px",
          width: "800px", // Set a fixed width for consistent PDF rendering
        }}
      >
        <div id="batch-printable-container" style={{ overflow: "visible" }}>
          {batchData.map((order, index) => (
            <div
              key={order.order_id}
              id={`batch-item-${order.order_id}`}
              style={{
                pageBreakAfter: "always",
                position: "relative",
                overflow: "visible",
              }}
            >
              <PrintableOrderDetails
                editable={false}
                data={order}
                AdditionalCostTotal={AdditionalCostTotal}
                setadditionalCosts={setadditionalCosts}
                additionalCosts={additionalCosts}
                deletedids={deletedids}
                setdeletedids={setdeletedids}
                setSnack={setSnack}
                setData={setData}
                setOrders={setOrders}
                cost={cost}
                setcost={setcost}
                value={value}
                setValue={setValue}
                open={open}
                additonalPrice={additonalPrice}
                setadditonalPrice={setadditonalPrice}
                setAdditionalCostTotal={setAdditionalCostTotal}
                selectedStatus={selectedStatus}
                setselectedStatus={setselectedStatus}
                Packinglist={
                  orderPdfType ? orderPdfType === "packing" : Packinglist
                }
                orderStatus={orderStatus}
              />
              {Array.isArray(open[0]) && (
                <div
                  style={{
                    position: "absolute",
                    bottom: "10px",
                    right: "10px",
                    fontSize: "12px",
                    color: "var(--color-ui-text-muted)",
                    fontWeight: "500",
                  }}
                >
                  {t("orderDetails.pageOf", { page: index + 1, total: batchData.length })}
                </div>
              )}
              {index < batchData.length - 1 && (
                <div
                  className="html2pdf__page-break"
                  style={{ height: "1px" }}
                />
              )}
            </div>
          ))}
        </div>
      </div>
      <div>
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={open}
          onClose={handleClose}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          {useNewDesign ? (
            // Phones: a full-screen sheet. From tablets up: the centred window.
            <div className="absolute left-[0px] top-[0px] flex h-full w-full max-w-[1400px] flex-col overflow-hidden bg-ui-page pb-[env(safe-area-inset-bottom,0px)] shadow-ui-md focus:outline-none md:left-1/2 md:top-1/2 md:h-auto md:max-h-[94vh] md:w-[96vw] md:-translate-x-1/2 md:-translate-y-1/2 md:rounded-lg md:pb-0">
              {loading && <OrderViewSkeleton />}
              {loading === false && (
                <>
                  <div className="shrink-0">
                    {Array.isArray(open[0]) && (
                      <div className="flex items-center justify-between gap-3 bg-ui-inverted px-4 py-2.5">
                        <span className="text-sm font-semibold text-white">
                          {t("orderDetails.batchOrders", { count: batchData.length })}
                        </span>
                        <button
                          type="button"
                          onClick={handleClose}
                          title={t("common:actions.close")}
                          className="flex h-10 w-10 items-center justify-center rounded-md text-white/70 transition-colors hover:bg-white/10 hover:text-white lg:h-7 lg:w-7 [@media(pointer:coarse)]:h-10 [@media(pointer:coarse)]:w-10"
                        >
                          <RxCross2 size={16} />
                        </button>
                      </div>
                    )}
                    {Array.isArray(open[0]) && (
                      <div className="flex flex-wrap justify-between items-center gap-2 px-4 py-2 bg-brand-light">
                        <span className="text-xs font-semibold text-brand-hover">
                          {t("orderDetails.ordersSelected", { count: batchData.length })}
                        </span>
                        <div className="flex w-full items-center gap-2 sm:w-auto">
                          <button
                            onClick={downloadAllPdfs}
                            disabled={downloadingBatch}
                            className="flex-1 sm:flex-[0_1_auto] min-h-[40px] lg:min-h-0 [@media(pointer:coarse)]:min-h-[40px] text-[12px] lg:text-[11px] font-bold text-white bg-brand hover:bg-brand-hover px-3 py-1.5 rounded-md transition-all flex items-center gap-1.5 shadow-sm min-w-[120px] justify-center"
                          >
                            {downloadingBatch &&
                            (downloadStatus.includes("GENERATING PDF") ||
                              downloadStatus === "PREPARING...") ? (
                              <div className="w-3 h-3 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                            ) : (
                              <MdDownload size={14} />
                            )}
                            {downloadingBatch &&
                            (downloadStatus.includes("GENERATING PDF") ||
                              downloadStatus === "PREPARING...")
                              ? downloadStatus === "PREPARING..."
                                ? t("orderDetails.preparing")
                                : t("orderDetails.generating")
                              : t("orderDetails.mergedPdfCaps")}
                          </button>
                          <button
                            onClick={downloadIndividualPdfs}
                            disabled={downloadingBatch}
                            className="flex-1 sm:flex-[0_1_auto] min-h-[40px] lg:min-h-0 [@media(pointer:coarse)]:min-h-[40px] text-[12px] lg:text-[11px] font-bold text-brand bg-ui-surface border border-brand hover:bg-brand-light px-3 py-1.5 rounded-md transition-all flex items-center gap-1.5 shadow-sm min-w-[120px] justify-center"
                          >
                            {downloadingBatch &&
                            !downloadStatus.includes("GENERATING PDF") &&
                            downloadStatus !== "PREPARING..." ? (
                              <div className="w-3 h-3 border-2 border-ui-border border-t-brand rounded-full animate-spin" />
                            ) : (
                              <MdDownload size={14} />
                            )}
                            {downloadingBatch &&
                            !downloadStatus.includes("GENERATING PDF") &&
                            downloadStatus !== "PREPARING..."
                              ? downloadStatusLabel(downloadStatus)
                              : t("orderDetails.individualPdfsCaps")}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                  <div
                    className={`min-h-0 flex-1 ${
                      Array.isArray(open[0])
                        ? "overflow-y-auto thin__scrollbar"
                        : "flex flex-col"
                    }`}
                  >
                    {batchData.map((order, index) => (
                      <div
                        key={order.order_id}
                        className={`${
                          Array.isArray(open[0])
                            ? "border-b-8 border-ui-page"
                            : "flex min-h-0 flex-1 flex-col"
                        }`}
                      >
                        <OrderView
                          data={order}
                          handleClose={handleClose}
                          downloadPdf={downloadPdf}
                          getPdf={buildPdf}
                          setSnack={setSnack}
                          AdditionalCostTotal={AdditionalCostTotal}
                          showHeader={!isBatch}
                          status={statusControl(order)}
                          // Status and charges, as the old view's
                          // "Fulfilment information" (not for packing lists
                          // or several orders at once, as there).
                          fulfilment={
                            !Packinglist && !isBatch && (showPrices || editable) ? (
                              <OrderFulfilment
                                editable={editable}
                                data={order}
                                AdditionalCostTotal={AdditionalCostTotal}
                                setadditionalCosts={setadditionalCosts}
                                additionalCosts={additionalCosts}
                                deletedids={deletedids}
                                setdeletedids={setdeletedids}
                                setSnack={setSnack}
                                setData={setOpenOrder}
                                setOrders={setOrders}
                                cost={cost}
                                setcost={setcost}
                                value={value}
                                setValue={setValue}
                                open={open}
                                additonalPrice={additonalPrice}
                                setadditonalPrice={setadditonalPrice}
                                setAdditionalCostTotal={setAdditionalCostTotal}
                                selectedStatus={selectedStatus}
                                setselectedStatus={setselectedStatus}
                                orderStatus={orderStatus}
                                onStatusChange={pickStatus}
                              />
                            ) : null
                          }
                        />
                      </div>
                    ))}
                  </div>
                </>
              )}
              {/* The status pop-up for the header's status and the
                  fulfilment section's, the same one the old view opens. */}
              {loading === false && !isBatch && batchData[0] && (
                <ConformModal
                  data={batchData[0]}
                  setData={setOpenOrder}
                  open={betaStatusModal}
                  setOpen={closeBetaStatusModal}
                  prefill={prefill}
                  selectedStatus={selectedStatus}
                  orderStatus={orderStatus}
                  setOrders={setOrders}
                  setselectedStatus={setselectedStatus}
                  setSnack={setSnack}
                />
              )}
            </div>
          ) : (
            // order_detail_modal_sheet: the phone and tablet layout in
            // OrderDetails.css (a full-screen sheet on phones).
            <div
              className="proddetails__desc_modal detail__modal_order_view order_detail_modal_sheet"
              style={{
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                position: "absolute",
                backgroundColor: "var(--color-ui-surface)",
                padding: "0px 20px 20px 20px",
                maxHeight: "80%",
                overflowY: "auto",
              }}
            >
              {loading && (
                <div
                  style={{
                    width: "100%",
                    height: "250px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <CarrierInnerTableLoader />
                </div>
              )}
              {loading === false && (
                <>
                  <div className="sticky top-[-1px] z-[100] bg-ui-surface pb-2">
                    <Header
                      order={
                        Array.isArray(open[0])
                          ? { order_id: t("orderDetails.batchNumber", { number: open[0].length }) }
                          : data
                      }
                      handleClose={handleClose}
                      downloadPdf={
                        Array.isArray(open[0]) ? downloadAllPdfs : downloadPdf
                      }
                      type="show"
                    />
                    {Array.isArray(open[0]) && (
                      <div className="flex flex-wrap justify-between items-center gap-2 px-4 py-2 bg-brand-light">
                        <span className="text-xs font-semibold text-brand-hover">
                          {t("orderDetails.ordersSelected", { count: batchData.length })}
                        </span>
                        <div className="flex w-full items-center gap-2 sm:w-auto">
                          <button
                            onClick={downloadAllPdfs}
                            disabled={downloadingBatch}
                            className="flex-1 sm:flex-[0_1_auto] min-h-[40px] lg:min-h-0 [@media(pointer:coarse)]:min-h-[40px] text-[12px] lg:text-[11px] font-bold text-white bg-brand hover:bg-brand-hover px-3 py-1.5 rounded-md transition-all flex items-center gap-1.5 shadow-sm min-w-[120px] justify-center"
                          >
                            {downloadingBatch &&
                            (downloadStatus.includes("GENERATING PDF") ||
                              downloadStatus === "PREPARING...") ? (
                              <div className="w-3 h-3 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                            ) : (
                              <MdDownload size={14} />
                            )}
                            {downloadingBatch &&
                            (downloadStatus.includes("GENERATING PDF") ||
                              downloadStatus === "PREPARING...")
                              ? downloadStatus === "PREPARING..."
                                ? t("orderDetails.preparing")
                                : t("orderDetails.generating")
                              : t("orderDetails.mergedPdfCaps")}
                          </button>
                          <button
                            onClick={downloadIndividualPdfs}
                            disabled={downloadingBatch}
                            className="flex-1 sm:flex-[0_1_auto] min-h-[40px] lg:min-h-0 [@media(pointer:coarse)]:min-h-[40px] text-[12px] lg:text-[11px] font-bold text-brand bg-ui-surface border border-brand hover:bg-brand-light px-3 py-1.5 rounded-md transition-all flex items-center gap-1.5 shadow-sm min-w-[120px] justify-center"
                          >
                            {downloadingBatch &&
                            !downloadStatus.includes("GENERATING PDF") &&
                            downloadStatus !== "PREPARING..." ? (
                              <div className="w-3 h-3 border-2 border-ui-border border-t-brand rounded-full animate-spin" />
                            ) : (
                              <MdDownload size={14} />
                            )}
                            {downloadingBatch &&
                            !downloadStatus.includes("GENERATING PDF") &&
                            downloadStatus !== "PREPARING..."
                              ? downloadStatusLabel(downloadStatus)
                              : t("orderDetails.individualPdfsCaps")}
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="proddetails__desc_modalcontent warehouse_cust_prod">
                    {batchData.map((order, index) => (
                      <div
                        key={order.order_id}
                        className={
                          index > 0
                            ? "mt-10 border-t-2 border-dashed border-ui-border pt-10"
                            : ""
                        }
                      >
                        <Row className="mx-auto">
                          <Col md={12} className="mx-auto">
                            <Row>
                              <OrderDetails
                                data={order}
                                AdditionalCostTotal={AdditionalCostTotal}
                                Packinglist={Packinglist}
                                setSnack={setSnack}
                              />
                              <ShipmentSummary
                                data={order}
                                selectedStatus={selectedStatus}
                                orderStatus={orderStatus}
                              />
                              <Trackingandnotes data={order} />
                              {/* Warehouse app 0.8.0: what was scanned (store logins only). */}
                              {!Packinglist && !Array.isArray(open[0]) && (
                                <Col md={12} className="mt-3">
                                  <OrderScans data={order} />
                                </Col>
                              )}
                              {!Packinglist && !Array.isArray(open[0]) && (
                                <Fulfilment
                                  editable={editable}
                                  data={order}
                                  AdditionalCostTotal={AdditionalCostTotal}
                                  setadditionalCosts={setadditionalCosts}
                                  additionalCosts={additionalCosts}
                                  deletedids={deletedids}
                                  setdeletedids={setdeletedids}
                                  setSnack={setSnack}
                                  setData={setData}
                                  setOrders={setOrders}
                                  cost={cost}
                                  setcost={setcost}
                                  value={value}
                                  setValue={setValue}
                                  open={open}
                                  additonalPrice={additonalPrice}
                                  setadditonalPrice={setadditonalPrice}
                                  setAdditionalCostTotal={
                                    setAdditionalCostTotal
                                  }
                                  selectedStatus={selectedStatus}
                                  setselectedStatus={setselectedStatus}
                                  orderStatus={orderStatus}
                                  initial={open[2] ? true : false}
                                />
                              )}
                            </Row>
                          </Col>
                        </Row>
                      </div>
                    ))}
                  </div>
                </>
              )}
            </div>
          )}
        </Modal>
      </div>
    </>
  );
}
